// Tipagem do usuário retornado pela API
export interface IUser {
  id: number;
  idEnterprise: number;
  name: string;
  email: string;
  password: string;
  isActive: boolean;
  isFaceCodeAuth: boolean;
  isFaceTokenAuth: boolean;
  role: string;
  createdAt: string;
  enterprise: string;
  avatar: string;
  cover: string;
  theme: number;
  tokenJWT: string;
}

export const needsMetaToken = (user: IUser) => {
  return !user.isFaceCodeAuth || !user.isFaceTokenAuth;
  // return user.isFaceCodeAuth && !user.isFaceTokenAuth;
};
